import React, { useState } from 'react';
import { Text, useId } from '@fluentui/react-components';
import { useDropdownStyles } from './Dropdown.styles';
import { IDropdownComponentProps } from './Dropdown.types';
import { ChevronDown24Regular, ChevronUp24Regular } from '@fluentui/react-icons';
import { CareerHubModuleReactContext } from '@careerhub/common';
import { FeatureName } from '../resources/TelemetryEventDetails';
/**
 * Error component with title and description
 */
export const Dropdown = (props: IDropdownComponentProps) => {
  let { title, mainContent, listItems, dropdownIndex } = props;
  const styles = useDropdownStyles();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { telemetryClient } = React.useContext(CareerHubModuleReactContext);
  const contentId = useId('faq-content');

  const toggleDropdown = () => {
    if (dropdownIndex && !isOpen) {
      telemetryClient.logButtonClick(FeatureName.FAQ, `OpenedQ${dropdownIndex}`);
    }
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <button
        type="button"
        className={styles.container}
        aria-expanded={isOpen}
        aria-controls={contentId}
        onClick={toggleDropdown}
      >
        <Text weight="bold" className={styles.titleContainer}>
          {title || ''}
        </Text>
        {isOpen ? <ChevronUp24Regular aria-hidden="true" /> : <ChevronDown24Regular aria-hidden="true" />}
      </button>
      {isOpen && (
        <div id={contentId} className={styles.dropDownContent}>
          {mainContent && <Text style={{ whiteSpace: 'pre-wrap' }}>{mainContent}</Text>}
          {listItems && listItems?.length > 0 && (
            <ul>
              {listItems.map((item, index) => {
                return <li key={index}>{item}</li>;
              })}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};
